
import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import GlobeComponent from "./globe.jsx";
import TimeLine from "./timeline.jsx";

export default class CrudeOilGlobe extends BaseComponent {
  constructor(props) {
    super(props);
    this.time = [
      'Jan 2010',
      'Feb 2010',
      'Mar 2010',
      'Apr 2010',
      'May 2010',
      'Jun 2010',
      'Jul 2010',
      'Aug 2010',
      'Sep 2010',
      'Oct 2010',
      'Nov 2010',
      'Dec 2010',
      'Jan 2011',
      'Feb 2011',
      'Mar 2011',
      'Apr 2011',
      'May 2011',
      'Jun 2011',
      'Jul 2011',
      'Aug 2011',
      'Sep 2011',
      'Oct 2011',
      'Nov 2011',
      'Dec 2011',
      'Jan 2012',
      'Feb 2012',
      'Mar 2012',
      'Apr 2012',
      'May 2012',
      'Jun 2012',
      'Jul 2012',
      'Aug 2012',
      'Sep 2012',
      'Oct 2012',
      'Nov 2012',
      'Dec 2012',
      'Jan 2013',
      'Feb 2013',
      'Mar 2013',
      'Apr 2013',
      'May 2013',
      'Jun 2013',
      'Jul 2013',
      'Aug 2013',
      'Sep 2013',
      'Oct 2013',
      'Nov 2013',
      'Dec 2013',
      'Jan 2014',
      'Feb 2014',
      'Mar 2014',
      'Apr 2014',
      'May 2014',
      'Jun 2014',
      'Jul 2014',
      'Aug 2014',
      'Sep 2014',
      'Oct 2014'
    ];
  }

  componentDidMount() {
    this.loadDependencies()
      .then(() => {
        this.globeBody = <div style={{position: 'relative'}} id="globe-body">
          <GlobeComponent />
          <TimeLine time={this.time}/>
        </div>;
        this.forceUpdate();
      });
  }

  loadDependencies() {
    return new Promise((resolve, reject) => {
      try {
        require.ensure([], require => {
          require('../../../../vendors/webgl-globe-bar.js');
          require('../../../../vendors/range-slider-1.1.0.js');
          require('../../../../vendors/tween.js');
          resolve();
        });
      }
      catch(err) {
        reject(err);
      }
    });
  }

  componentDidUpdate() {
    $('#globe-body').css('opacity', '0');

    setTimeout(() => {
      $('#dashboard-preloader').css('display', 'none');
      $('#globe-body').css('display', 'none').css('opacity', '1').fadeIn({duration: 600});
      this.publish(InternalEvent.Dashboard.RENDERED);
    }, 1);
  }

  render() {
    return (
      <div>
        {this.globeBody}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/globe/crude-oil/crudeOilGlobe.jsx